import type { IGroupedListGroup } from "./grouped-list.types";

/**
 * An option's element id within a list.
 * @param listId The list's element id.
 * @param itemId The item's id.
 * @returns The option's id.
 */
export const getOptionId = (listId: string, itemId: string): string => `${listId}-option-${itemId}`;

/**
 * A group header's element id within a list.
 * @param listId  The list's element id.
 * @param groupId The group's id.
 * @returns The header's id.
 */
export const getGroupHeaderId = (listId: string, groupId: string): string => `${listId}-group-${groupId}`;

/**
 * The items the keyboard can move through, top to bottom: every item that is not disabled, in a group that is not
 * collapsed.
 * @param groups            The groups on show.
 * @param collapsedGroupIds The groups the user has collapsed.
 * @param isItemDisabled    Whether an item can't be chosen yet.
 * @returns The selectable items, in display order.
 */
export const getSelectableItems = <Item>(
    groups: readonly IGroupedListGroup<Item>[],
    collapsedGroupIds: ReadonlySet<string>,
    isItemDisabled?: (item: Item) => boolean
): Item[] =>
    groups
        .filter(({ id }) => !collapsedGroupIds.has(id))
        .flatMap(({ items }) => items)
        .filter((item) => isItemDisabled?.(item) !== true);
